import { render, staticRenderFns } from "./SlicePressAssets.vue?vue&type=template&id=dcab12d0&lang=pug&"
import script from "./SlicePressAssets.vue?vue&type=script&lang=js&"
export * from "./SlicePressAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports